import { ActionType } from '../constants/ActionTypes'

export default function referFriendReducer(state = {}, action = {}) {
    switch (action.type) {
        case ActionType.GET_CLIENT_INVITES_SUCCESS:
            return {
                ...state,
                loading: false,
                invitesData: action.payload,
            }
        case ActionType.GET_CLIENT_INVITES_BEGIN:
            return {
                ...state,
                loading: true,
            }
        case ActionType.GET_CLIENT_INVITES_ERROR:
            return {
                ...state,
                loading: false,
            }

        //GROUPS
        case ActionType.GET_CLIENT_GROUPS_SUCCESS:
            return {
                ...state,
                loading: false,
                groupsData: action.payload,
            }
        case ActionType.GET_CLIENT_GROUPS_BEGIN:
            return {
                ...state,
                loading: true,
            }
        case ActionType.GET_CLIENT_GROUPS_ERROR:
            return {
                ...state,
                loading: false,
            }

        // BONUSES 
        case ActionType.GET_REFERRAL_BONUSES_SUCCESS:
            return {
                ...state,
                loading: false,
                bonuses: action.payload,
            }
        case ActionType.GET_REFERRAL_BONUSES_BEGIN:
            return {
                ...state,
                loading: true,
            }
        case ActionType.GET_REFERRAL_BONUSES_ERROR:
            return {
                ...state,
                loading: false,
            }

        case ActionType.GET_REFERRAL_BONUS_DETAILS_SUCCESS:
            return {
                ...state,
                detailsLoading: false,
                bonusDetails: action.payload,
            }
        case ActionType.GET_REFERRAL_BONUS_DETAILS_BEGIN:
            return {
                ...state,
                detailsLoading: true,
            }
        case ActionType.GET_REFERRAL_BONUS_DETAILS_ERROR:
            return {
                ...state,
                detailsLoading: false,
            }
            
        case ActionType.INVITE_FRIEND_SUCCESS:
            return {
                ...state,
                loading: false,
                bonusDetails: action.payload,
            }
            
        default:
            return state;
    }
    
}